/*
  Shareable renderer for displaying the name of a credential vault.
  Largely a copy/paste from the original table column.
*/
import React from 'react';
import { observer } from 'mobx-react';
import CredentialModel from 'app/stores/credential/CredentialModel';
import { Text } from 'core/components';
import LabelList from 'app/components/labels/LabelList';

interface Props {
  value: string;
  model: CredentialModel;
}

function CredentialNameRenderer({ value, model }: Props) {
  const { labels, collection } = model;
  const {
    // @ts-expect-error skipping type check
    discreteFilterValues: { labelMultiSelect }
  } = collection;

  return (
    <>
      <Text as="div" fontWeight="bold" fontSize={14} ellipsis maxWidth="100%">
        {value}
      </Text>
      {model.get('description') && (
        <Text as="div" small muted ellipsis>
          {model.get('description')}
        </Text>
      )}
      {/* @ts-expect-error skipping type check */}
      <LabelList mt="2px" labels={labels} priorityLabels={labelMultiSelect} labelMaxWidth={150} />
    </>
  );
}

export default observer(CredentialNameRenderer);
